import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchCategories']),
  ...buildCreateMutations(['createCategory']),
  ...buildUpdateMutations(['updateCategory', 'setDefaultCategory']),
  ...buildDeleteMutations(['removeCategory']),
};



// WEBPACK FOOTER //
// ./src/store/modules/category/mutations.js